import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Flex, Text } from '@olxbr/ds-web';
import { IconCard } from './IconCard';
import { ImageCard } from './ImageCard';
import { parseHTML } from '../../helpers/parseHTML';
import YoutubeCard from './YoutubeCard';
var CardTypes = {
  'image-card': ImageCard,
  'icon-card': IconCard,
  'youtube-card': YoutubeCard
};
export function Card(_ref) {
  var _CardTypes$cardType;
  var content = _ref.content,
    isMobile = _ref.isMobile,
    idPage = _ref.idPage;
  var cardType = content.type;
  var Card = (_CardTypes$cardType = CardTypes[cardType]) !== null && _CardTypes$cardType !== void 0 ? _CardTypes$cardType : CardTypes['image-card'];
  var getStyledText = function getStyledText(type, text, badgeText, badgeColor) {
    var parsedtext = parseHTML(text);
    if (type === 'title' && isMobile) {
      return /*#__PURE__*/React.createElement(Text.BodyMedium, {
        weight: "bold"
      }, parsedtext);
    } else if (type === 'title' && !isMobile && badgeText) {
      return /*#__PURE__*/React.createElement(Flex, {
        flexDirection: "row"
      }, /*#__PURE__*/React.createElement(Badge, {
        "aria-label": badgeText,
        color: badgeColor || "secondary"
      }, badgeText), /*#__PURE__*/React.createElement(Text.BodyLarge, {
        weight: "bold",
        display: "inline",
        marginLeft: "--spacing-1"
      }, parsedtext), " :");
    } else if (type === 'title' && !isMobile) {
      return /*#__PURE__*/React.createElement(Text.BodyLarge, {
        weight: "bold"
      }, parsedtext);
    } else if (type === 'description' && isMobile) {
      return /*#__PURE__*/React.createElement(Text.Caption, null, parsedtext);
    } else if (type === 'description' && !isMobile) {
      return /*#__PURE__*/React.createElement(Text.BodyMedium, {
        weight: "light"
      }, parsedtext);
    }
  };
  return /*#__PURE__*/React.createElement(Card, {
    content: content,
    getStyledText: getStyledText,
    isMobile: isMobile,
    idPage: idPage
  });
}
Card.propTypes = {
  content: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  idPage: PropTypes.string.isRequired
};
export default Card;